module.exports = __webpack_public_path__ + "static/media/resourcesSymptomTracking.975351df.png";